import { createCRUDHook } from './createCRUDHook';
import { DraftPartLoadingInstructionDto } from 'utils/models';
import { TBL_DRAFT_PART_MULTIPLIER } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<DraftPartLoadingInstructionDto>({
    entityName: 'DraftPartLoadingInstruction',
    endpoint: TBL_DRAFT_PART_MULTIPLIER,
  });

export const DraftPartLoadingInstructionContext = Context;
export const useDraftPartLoadingInstructionManager = useManager;
export const useDraftPartLoadingInstruction = useConsumer;
